import React from "react";
import SettingsHeader from "./SettingsHeader";
import AddIcon from "@mui/icons-material/Add";
import DepartmentSettingsDrawer from "./DepartmentSettingsDrawer";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteWarningModal from "./DeleteWarningModal";

function DepartmentSettingsDisplay(props) {
  const default_data = {
    role_type: null,
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [modalData, setModalData] = React.useState(default_data);
  const [modalEdit, setModalEdit] = React.useState(false);


  const [openDeleteWarningModal, setOpenDeleteWarningModal] = React.useState(false);
  const [departmentDeleteImpact, setDepartmentDeleteImpact] = React.useState(null);
  const [departmentDeleteReplacementId, setDepartmentDeleteReplacementId] = React.useState("");
  const [isDepartmentDeleteImpactLoading, setIsDepartmentDeleteImpactLoading] = React.useState(false);

  const handleOpenDeleteWarningModal = async (department) => {
    setSelectedDepartment(department);
    setDepartmentDeleteImpact(null);
    setDepartmentDeleteReplacementId("");
    setOpenDeleteWarningModal(true);

    if (!department?.id || !props.get_department_delete_impact) {
      return;
    }

    setIsDepartmentDeleteImpactLoading(true);
    const impactPayload = await props.get_department_delete_impact(department.id);
    setDepartmentDeleteImpact(impactPayload);
    setIsDepartmentDeleteImpactLoading(false);
  };
  const handleCloseDeleteWarningModal = () => {
    setOpenDeleteWarningModal(false);
    setDepartmentDeleteImpact(null);
    setDepartmentDeleteReplacementId("");
    setSelectedDepartment(null);
  };

  const [selectedDepartment, setSelectedDepartment] = React.useState(null)
  const deleteReplacementDepartmentOptions = React.useMemo(
    () =>
      (props.departments || []).filter(
        (department) => department.id !== selectedDepartment?.id
      ),
    [props.departments, selectedDepartment]
  );

  return (
    <div>
      {/* <SettingsHeader title="Department Settings" /> */}
      <div className="w-full py-4 flex justify-end">
        {props.permissionRole !== "company_manager" && <Tooltip title="Add department">
          <button
            className="bg-violet-700 hover:bg-violet-800 text-white px-3 py-2 rounded-lg flex items-center gap-2 text-sm"
            onClick={() => {
              setModalData(default_data);
              setModalEdit(false);
              handleOpen();
            }}
          >
            <AddIcon style={{ fontSize: "18px" }} /><span>Add department</span>
          </button>
        </Tooltip>}
      </div>
      <div className="flex flex-col">
        <div className="overflow-x-auto rounded-xl border border-slate-200">
          <div className="min-w-full">
            <div className="overflow-hidden">
              <table className="min-w-full divide-y divide-slate-200">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="w-[25%] py-3.5 pl-6 pr-3 text-left text-xs text-slate-500 font-medium"
                    >
                      Department
                    </th>
                    <th
                      scope="col"
                      className="flex-1 px-3 py-3.5 text-left text-xs text-slate-500 font-medium"
                    >
                      Roles
                    </th>
                    <th
                      scope="col"
                      className="w-1/12 relative py-3.5 pl-3 pr-6 text-right text-xs font-medium text-slate-500"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200 bg-white">
                  {Array.isArray(props.departments) && props.departments.length === 0 && <tr>
                    <td colSpan={3} className="px-6 py-10 text-center">
                      <h3 className="text-sm font-semibold text-slate-900">No departments yet</h3>
                      <p className="mx-auto mt-2 max-w-md text-sm leading-relaxed text-slate-500">Departments group related roles so you can plan labor budgets and track labor costs together.</p>
                    </td>
                  </tr>}
                  {props.departments?.map((department, departmentIndex) => (
                    <tr key={departmentIndex}>
                      <td className="whitespace-nowrap py-5 pl-6 pr-3 text-sm">
                        <div>{department.role_type}</div>
                      </td>
                      <td className="whitespace-nowrap px-3 py-5 text-sm text-slate-900">
                        <div className="w-full flex flex-wrap items-center gap-2">
                          {Array.isArray(props.roles) &&
                            props.roles
                              .filter(
                                (r, i) => r.role_type === department.role_type
                              )
                              .map((role, roleIndex) => (
                                <div key={roleIndex} className="bg-violet-100 text-violet-700 rounded px-3 py-1">
                                  {role.role_name}
                                </div>
                              ))}
                        </div>
                      </td>
                      <td className="relative whitespace-nowrap py-5 pl-3 pr-6 text-right text-sm font-medium flex flex-row items-center gap-5 justify-end">
                        {props.permissionRole !== "company_manager" &&
                          <div className="flex items-center justify-end w-32 space-x-3">
                            <Tooltip title="Edit">
                              <IconButton
                                className="text-slate-500 ml-4"
                                sx={{ backgroundColor: "#f8fafc" }}
                                onClick={() => {
                                  setModalData(department);
                                  setModalEdit(true);
                                  handleOpen();
                                }}
                              >
                                <EditOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                              <IconButton
                                className="text-slate-500"
                                sx={{ backgroundColor: "#f8fafc" }}
                                onClick={() => {
                                  handleOpenDeleteWarningModal(department)
                                }}
                              >
                                <DeleteOutlinedIcon />
                              </IconButton>
                            </Tooltip>
                          </div>
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="border-b border-slate-200"></div>
            </div>
          </div>
        </div>
      </div>
      <DepartmentSettingsDrawer
        open={open}
        onClose={handleClose}
        modalData={modalData}
        modalEdit={modalEdit}
        edit_department={props.edit_department}
        isSavingData={props.isSavingData}
        store_name={props.store_name}
      />
      <DeleteWarningModal
        type="department"
        open={openDeleteWarningModal}
        handleClose={handleCloseDeleteWarningModal}
        delete_function={props.edit_department}
        selectedItem={selectedDepartment}
        availableDepartments={deleteReplacementDepartmentOptions}
        deleteImpact={departmentDeleteImpact}
        deleteImpactLoading={isDepartmentDeleteImpactLoading}
        replacementDepartmentId={departmentDeleteReplacementId}
        onReplacementDepartmentChange={setDepartmentDeleteReplacementId}
      />
    </div>
  );
}

export default DepartmentSettingsDisplay;
